import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { usePermission } from '../../../DataStore/PermissionContext';

const Permission = () => {
  const { loadPermissions, permissions, loading, setAccessAllocation } = usePermission();
  const [selected, setSelected] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    loadPermissions();
  }, []);

  const toggleSelection = (key) => {
    setSelected((prev) =>
      prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key]
    );
  };

  const isSelected = (key) => selected.includes(key);

  const handleAssignRole = () => {
    setAccessAllocation({
      show: true,
      permissions: selected,
      callback: () => setSelected([]),
    });
  };

  const menu = () => (
    <>
        <button type="button" tabIndex="0" className="dropdown-item" onClick={() => setSelected([])}>
            <i className="dropdown-icon fa fa-eraser"></i>
            <span>Clear Selection</span>
        </button>
         {selected.length > 0 && <button type="button" tabIndex="0" className="dropdown-item" onClick={handleAssignRole}>
            <i className="dropdown-icon fa fa-user"></i>
            <span>Assign to Role</span>
        </button>}
   </>
  );

  

  const filteredPermissions = permissions?.filter((perm) => {
    const q = searchQuery.toLowerCase();
    return (
      perm.permission_key.toLowerCase().includes(q) ||
      perm.description?.toLowerCase().includes(q)
    );
  }) || [];

  return (
    <SettingContainer
        title={`Permissions ${selected.length > 0 ? `(${selected.length} selected)` : ''}`}
        icon="fa fa-shield-halved" 
        Menu={menu}
        >
      <div className="mb-4 mt-2 px-2">
        <div className="input-group" style={{ 
            borderRadius: '10px', 
            overflow: 'hidden', 
            border: '1px solid #E2E8F0',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
        }}>
          <span className="input-group-text bg-white border-0 text-muted">
            <i className="fa fa-search"></i>
          </span>
          <input
            type="text"
            className="form-control border-0 shadow-none"
            style={{ padding: '12px 10px', fontSize: '14px' }}
            placeholder="Search permissions by name or description..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {loading && <ActivityLoader />}

      {!loading && filteredPermissions.length === 0 && (
        <Notification message="No permissions found matching your search." />
      )}

      {!loading && filteredPermissions.length > 0 && (
        // Inside the filteredPermissions mapping section
      <div className="row overflow-auto pr-2" style={{ maxHeight: '50vh', margin: '0' }}>
        {filteredPermissions.map((perm) => {
          const selected = isSelected(perm.id);
          return (
            <div key={perm.id} className="col-md-6 mb-3 px-2">
              <div
                onClick={() => toggleSelection(perm.id)}
                className={`permission-card ${selected ? 'selected' : ''}`}
              >
                <div className="me-3">
                  <span style={{ 
                    display: 'block', 
                    fontWeight: '700', 
                    fontSize: '14px', 
                    color: selected ? '#4F46E5' : '#1E293B',
                    letterSpacing: '0.02em',
                    textTransform: 'uppercase'
                  }}>
                    {perm.permission_key}
                  </span>
                  <small style={{ 
                    color: '#64748B', 
                    fontSize: '12px', 
                    lineHeight: '1.4',
                    display: 'block',
                    marginTop: '4px'
                  }}>
                    {perm.description}
                  </small>
                </div>
                <div className="d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selected}
                    readOnly // Let the parent div handle the click logic
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      )}

    </SettingContainer>
  );
};

export default Permission;
